import { render, staticRenderFns } from "./AnswersImageResultList.vue?vue&type=template&id=49e036fd&"
import script from "./AnswersImageResultList.vue?vue&type=script&lang=js&"
export * from "./AnswersImageResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports